import DocumentsStep from "./DocumentsStep";
import validationSchema from "./validationSchema";

const step = { StepComponent: DocumentsStep, validationSchema };

export default step;
